const ThumbnailGenerateFallbackType = {
  Original: "ORIGINAL"
};

export { ThumbnailGenerateFallbackType };
//# sourceMappingURL=thumbnail-generate-fallback-type.mjs.map
